import { connect } from 'react-redux';
import FeedTable from '../../../components/table/feed/FeedTable';

import { getDeviceBreakpoint } from '../../../service/device';

function mapStateToProps({ device }) {
    return { breakpoint: getDeviceBreakpoint(device.windowWidth) };
}

export default connect(mapStateToProps)(FeedTable);



/** WEBPACK FOOTER **
 ** /src/shared/containers/table/feed/FeedTable.js
 **/